import React from 'react'

interface Props {
  children: React.ReactNode
  size?: Size
  className?: string
}

function Typography({children, size = 'md', className = ''}: Props) {
  const styles = {
    xs: 'text-white font-medium text-xs',
    sm: 'text-white font-medium text-sm',
    sm2: 'text-sub-300 font-medium text-sm md:text-md',
    md: 'text-sub-400 font-medium text-sm md:text-md lg:text-lg',
    md2: 'text-sub-400 font-medium text-lg',
    md3: 'text-white font-medium text-md sm:text-lg md:text-xl',
    lg: 'text-sub-400 text-xl',
    lg2: 'text-on-background text-2xl md:text-3xl',
    xl: 'text-3xl md:text-4xl lg:text-5xl ',
    xxl: 'text-white font-medium text-3xl sm:text-4xl md:text-5xl lg:text-7xl ',
  }

  return <p className={` ${styles?.[size]} ${className}`}>{children}</p>
}

export default Typography
